import React from 'react';

export default class StreamingPanel extends React.Component {
  constructor(props) {
    super(props);    
  }

  render() {
    return (
      <div className="drawing-mode-container">
        <canvas
          ref={this.props.canvasRef}
          className="w-full border border-gray-300"          
        />        
      </div>
    );
  }
}